import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { closeDuplicateAddressDialog } from 'reducers/PersonDialogsReducer';
import Dialog from 'components/RMSDialog';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { handleError } from 'reducers/ErrorReducer';
import AddressHistory from './AddressHistory';
import AddressSOPs from './AddressSOPs';
import AddressParties from './AddressParties';
import AddressZones from './AddressZones';
import { getAddressDetails } from 'reducers/AddressReducer';
import AddressEdit from './AddressEdit';
import AddressCoordinates from './AddressCoordinates';
import AddressPrePlan from './AddressPrePlan';
import RMSAttachments2 from 'components/RMSAttachments/RMSAttachments2';

const useStyles = makeStyles((theme) => ({
  content: {
    margin: -theme.spacing(3),
  },
  closeButton: { color: theme.button.color },
}));

function Address(props) {
  const classes = useStyles();
  const { ptsAddressID, copyAddress } = props;
  const [tab, setTab] = useState('edit');
  const [address, setAddress] = useState(null);
  const mountedRef = useRef(true);
  const newAddress = Boolean(!ptsAddressID || copyAddress);

  useEffect(() => {
    if (props.tab) setTab(props.tab);
    getAddressData();
    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line
  }, [props.tab]);

  const getAddressData = async () => {
    try {
      const data = await getAddressDetails(ptsAddressID);
      if (!mountedRef.current) return;
      data?.data.length && setAddress(data.data[0]);
    } catch (err) {
      props.handleError(err, 'Error receiving event location data.');
    }
  };

  const close = (data) => {
    props.closeDuplicateAddressDialog(data);
  };
  const renderActions = () => {
    return (
      <>
        <Button color="primary" onClick={close} className={classes.closeButton}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  return (
    <Dialog
      toolbar
      onClose={close}
      title={newAddress ? 'Add Address' : 'Edit Address'}
      actions={renderActions()}
      fullScreen>
      <div className={classes.content}>
        <Paper square>
          <Tabs value={tab} onChange={(ev, val) => setTab(val)}>
            <Tab label="Edit Address" value="edit" />
            <Tab label="Attachments" value="attachments" disabled={newAddress} />
            <Tab label="Coordinates" value="coordinates" disabled={newAddress} />
            <Tab label="History" value="history" disabled={newAddress} />
            <Tab label="Parties" value="parties" disabled={newAddress} />
            <Tab label="Pre-Plan" value="pre-plan" disabled={newAddress} />
            <Tab label="SOPs" value="sops" disabled={newAddress} />
            <Tab label="Zones" value="zones" disabled={newAddress} />
          </Tabs>
        </Paper>
        {tab === 'edit' && <AddressEdit ptsAddressID={ptsAddressID} copyAddress={copyAddress} />}
        {!newAddress && (
          <>
            {tab === 'history' && <AddressHistory ptsAddressID={ptsAddressID} />}
            {tab === 'sops' && <AddressSOPs ptsAddressID={ptsAddressID} />}
            {tab === 'parties' && <AddressParties ptsAddressID={ptsAddressID} />}
            {tab === 'zones' && <AddressZones ptsAddressID={ptsAddressID} address={address} />}
            {tab === 'attachments' && <RMSAttachments2 type="Address" id={ptsAddressID} />}
            {tab === 'coordinates' && <AddressCoordinates ptsAddressID={ptsAddressID} />}
            {tab === 'pre-plan' && <AddressPrePlan ptsAddressID={ptsAddressID} />}
          </>
        )}
      </div>
    </Dialog>
  );
}

export default connect(null, {
  closeDuplicateAddressDialog,
  handleError,
})(Address);
